import { render } from "./ColorSpace.vue?vue&type=template&id=5555c42f&scoped=true"
import script from "./ColorSpace.vue?vue&type=script&lang=js"
export * from "./ColorSpace.vue?vue&type=script&lang=js"

import "./ColorSpace.vue?vue&type=style&index=0&id=5555c42f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5555c42f"

export default script